/**
 * Tabs Component
 */

// get tab links, and tab content
const createTabEvents = element => {
  const tabLinks = element.querySelectorAll('[data-tabs="tab"]')
  const tabContent = element.querySelectorAll('[data-tabs="tab-panel"]')

  tabLinks.forEach((tabLink, index) => {
    tabLink.addEventListener('click', () => {
      removeActiveStates(tabLinks, tabContent)
      addActiveState(tabLink, tabContent[index])
    })
  })
}

// Remove active states from all tabs and tab content
const removeActiveStates = (tabLinks, tabContent) => {
  tabLinks.forEach(tabLink => {
    tabLink.classList.remove('is-active')
    tabLink.setAttribute('tabindex', '-1')
    tabLink.setAttribute('aria-selected', false)

    tabContent.forEach(content => {
      content.classList.add('display-none')
      content.setAttribute('aria-hidden', true)
    })
  })
}

// Add active states to correct tab and tab content
const addActiveState = (tabLink, tabContent) => {
  tabLink.classList.add('is-active')
  tabLink.setAttribute('tabindex', '0')
  tabLink.setAttribute('aria-selected', true)

  // prevents console error when tab content is dynamic (i.e. rate chart)
  if (tabContent !== undefined) {
    tabContent.classList.remove('display-none')
    tabContent.classList.add('fade-in')
    tabContent.setAttribute('aria-hidden', false)
  }
}

// Bind events to all individual toggle type components on page
const bindTabEvents = selector => {
  const elements = document.querySelectorAll(selector)

  if (elements.length > 0) {
    elements.forEach(element => {
      createTabEvents(element)
    })
  }
}

bindTabEvents('[data-tabs="tabs-container"]')
